<template>
    <div>
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                v-if="model"
                ref="RkmForm"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            range
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            :start-validations="validations.periodo.date.start"
                            :end-validations="validations.periodo.date.end"
                            :max-date="additionals.dataAtual"
                            v-model="model.periodo.date"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            @change="unidadeChange()"
                            :disabled="!isPeriodoFill"
                            :options="form.unidades"
                            defaultOptionText="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field='id'
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            @change="localAtendimentoChange()"
                            :disabled="!isPeriodoFill"
                            :options="form.locaisAtendimento"
                            defaultOptionText="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.localAtendimentoId"
                            value-field='id'
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :validations="validations.idadeDe"
                            @blur="blurIdade()"
                            label="Idade de"
                            type="number"
                            v-model="model.idadeDe"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :validations="validations.idadeAte"
                            @blur="blurIdade()"
                            label="Até"
                            type="number"
                            v-model="model.idadeAte"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            @change="ocupacaoChange()"
                            :disabled="!isPeriodoFill"
                            :options="form.ocupacoes"
                            defaultOptionText="Todos"
                            label="CBO"
                            show-default-option
                            text-field="ocupacaoCodigoNome"
                            v-model="model.ocupacaoId"
                            value-field='id'
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            @change="usuarioChange()"
                            :disabled="!isPeriodoFill"
                            :options="form.usuarios"
                            defaultOptionText="Todos"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioId"
                            value-field='id'
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>

                    <rkm-col cols="6">
                        <rkm-form-select
                            @change="procedimentoChange()"
                            :disabled="!isPeriodoFill"
                            :options="form.procedimentos"
                            defaultOptionText="Todos"
                            label="Procedimento"
                            show-default-option
                            text-field="procedimentoCodigoNome"
                            v-model="model.procedimentoId"
                            value-field='id'
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            :options="form.status"
                            default-option-text="Todos"
                            label="Status"
                            show-default-option
                            text-field="nome"
                            v-model="model.status"
                            value-field="valor"
                        />
                    </rkm-col>

                    <rkm-col
                        class="text-nowrap"
                        cols="auto"
                    >
                        <rkm-button
                            :disabled="!isPeriodoFill"
                            :label="false"
                            @click="handleBuscar()"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :disabled="!isPeriodoFill"
                            :label="false"
                            @click="limpar()"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                    menu-class="auto-scroll"
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        @change="handleSelectedColumns"
                        :indeterminate="indeterminate"
                        class="mx-2"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="cols"
                        class="mx-2"
                        v-model="selectedCols"
                    />
                </rkm-dropdown>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="imprimir()"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="exportar()"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                class="mt-4"
                :fields="fields"
                :items="items"
                hide-pagination
                :sort-compare="sortCompare"
            >
                <template v-slot:cell(procedimento)="row">
                    {{ getStringProcedimento(row.item) }}
                </template>

                <template v-slot:cell(ocupacao)="row">
                    {{ getStringOcupacao(row.item) }}
                </template>

                <template #afterTable v-if="items.length > 0">
                    <rkm-row>
                        <rkm-col
                            cols="12"
                            class="total"
                        >
                            Total: {{ quantidadeTotal }}
                        </rkm-col>
                    </rkm-row>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>
// Mixins.
import { repository, error, data, object, stringCase, formats } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        fields() {

            let fields = [
                { key: 'index', label: '#', sortable: true },
                { key: 'procedimento', label: 'Procedimento', sortable: true },
            ]

            this.selectedCols.map(map => {

                const col = this.cols.find(find => find.value === map)
                fields.push({ key: col.value, label: col.text, sortable: true, })
            })

            fields.push(
                { key: 'quantidade', label: 'Quantidade', sortable: true },
            )

            return fields
        },
        validations() {

            let idadeAteMinValue = 0

            if (this.model.idadeDe != null && this.model.idadeDe != '') {

                idadeAteMinValue = this.model.idadeDe
            }

            return {
                periodo: {
                    date: {
                        start: { required: true },
                        end: { required: true },
                    },
                },
                idadeDe: { min: 0, min_value: 0 },
                idadeAte: { min: 0, min_value: idadeAteMinValue},
            }
        },
        isPeriodoFill() {
            return this.model.periodo.date.start != null && this.model.periodo.date.end != null
        }
    },
    created() {

        this.repositories = {
            relatorioQuantitativoProducao: this.getConectaSusRepository('prontoAtendimento.relatorioQuantitativoProducao'),
            impressao: this.getConectaSusRepository('impressao.prontoAtendimento'),
            export: this.getConectaSusRepository('exportacao.prontoAtendimento'),
        }

        this.load()
    },
    data: () => ({
        quantidadeTotal: 0,
        items: [],
        model: null,
        form: null,
        additionals: null,
        filterDefault: {},
        indeterminate: false,
        cols: [
            { value: 'ocupacao', text: 'CBO', },
            { value: 'profissionalNome', text: 'Profissional', },
            { value: 'status', text: 'Status' },
        ],
        selectedCols: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleSelectedColumns(selected) {

            if (selected) {

                this.cols.map(col => {

                    this.selectedCols.push(col.value)
                })

            } else {

                this.selectedCols = []
            }
        },
        sortCompare(a, b, key) {

            if (key === 'procedimento') {

                if (this.getStringProcedimento(a) > this.getStringProcedimento(b)) return 1
                else if (this.getStringProcedimento(a) < this.getStringProcedimento(b)) return -1
                else return 0

            } else if (key === 'ocupacao') {

                if (this.getStringOcupacao(a) > this.getStringOcupacao(b)) return 1
                else if (this.getStringOcupacao(a) < this.getStringOcupacao(b)) return -1
                else return 0

            } else {

                return false
            }
        },
        getStringProcedimento(item) {

            return `${this.formatProcedimento(item.procedimentoCodigo)} - ${item.procedimentoNome}`
        },
        getStringOcupacao(item) {

            return `${item.ocupacaoCodigo} - ${item.ocupacaoNome}`
        },
        load() {

            this.setLoading()

            this.repositories.relatorioQuantitativoProducao.list()
                .then(({ data }) => {

                    this.form = this.clone(data.form)
                    this.model = this.clone(data.model)
                    this.additionals = this.clone(data.additionals)

                    this.filterDefault = {
                        form: this.clone(this.form),
                        model: this.clone(this.model)
                    }

                    this.addPeriodoWatch()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addPeriodoWatch() {

            this.$watch('model.periodo', {
                deep: true,
                handler() {

                    this.model.unidadeId = null
                    this.model.localAtendimentoId = null
                    this.model.idadeDe = null
                    this.model.idadeAte = null
                    this.model.ocupacaoId = null
                    this.model.usuarioId = null
                    this.model.procedimentoId = null
                    this.model.status = null

                    this.form.unidades = []
                    this.form.locaisAtendimento = []
                    this.form.ocupacoes = []
                    this.form.usuarios = []
                    this.form.procedimentos = []
                    this.form.status = []

                    const filter = this.getFilter()

                    if (filter) {

                        this.setLoading()

                        this.repositories.relatorioQuantitativoProducao.list(filter)
                            .then(({ data }) => {

                                this.form = this.clone(data.form);

                                this.$nextTick().then(() => this.setUnidadeLogada(data.form))
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                }
            })
        },
        setUnidadeLogada() {

            const unidade = this.form.unidades.find(unidade => unidade.id === this.form.unidadeLogada.unidadeId)

            if (unidade) {
                this.model.unidadeId = unidade.id
            }

            const infraestrutura = this.form.locaisAtendimento.find(infraestrutura =>
                infraestrutura.id === this.form.unidadeLogada.infraestruturaId)

            if (infraestrutura) {
                this.model.localAtendimentoId = infraestrutura.id
            }
        },
        handleBuscar() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.items = []

                    this.repositories.relatorioQuantitativoProducao.index(this.getFilter())
                        .then(({ data }) => {

                            this.items = data.procedimentosAtendimentos
                            this.quantidadeTotal = data.quantidadeTotal
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        unidadeChange() {

            this.model.localAtendimentoId = null
            this.model.idadeDe = null
            this.model.idadeAte = null
            this.model.ocupacaoId = null
            this.model.usuarioId = null
            this.model.procedimentoId = null
            this.model.status = null

            this.form.locaisAtendimento = []
            this.form.ocupacoes = []
            this.form.usuarios = []
            this.form.procedimentos = []
            this.form.status = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioQuantitativoProducao.list(filter)
                    .then(({ data }) => {

                        this.form.locaisAtendimento = this.clone(data.form.locaisAtendimento)
                        this.form.ocupacoes = this.clone(data.form.ocupacoes)
                        this.form.usuarios = this.clone(data.form.usuarios)
                        this.form.procedimentos = this.clone(data.form.procedimentos)
                        this.form.status = this.clone(data.form.status)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        localAtendimentoChange() {

            this.model.idadeDe = null
            this.model.idadeAte = null
            this.model.ocupacaoId = null
            this.model.usuarioId = null
            this.model.procedimentoId = null
            this.model.status = null

            this.form.ocupacoes = []
            this.form.usuarios = []
            this.form.procedimentos = []
            this.form.status = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioQuantitativoProducao.list(filter)
                    .then(({ data }) => {

                        this.form.ocupacoes = this.clone(data.form.ocupacoes)
                        this.form.usuarios = this.clone(data.form.usuarios)
                        this.form.procedimentos = this.clone(data.form.procedimentos)
                        this.form.status = this.clone(data.form.status)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        blurIdade() {

            if (this.model.idadeDe !== null && this.model.idadeDe >= 0
                || this.model.idadeAte !== null && this.model.idadeAte >= 0) {

                this.model.ocupacaoId = null
                this.model.usuarioId = null
                this.model.procedimentoId = null
                this.model.status = null

                this.form.ocupacoes = []
                this.form.usuarios = []
                this.form.procedimentos = []
                this.form.status = []

                const filter = this.getFilter()

                if (filter) {

                    this.setLoading()

                    this.repositories.relatorioQuantitativoProducao.list(filter)
                        .then(({ data }) => {

                            this.form.ocupacoes = this.clone(data.form.ocupacoes)
                            this.form.usuarios = this.clone(data.form.usuarios)
                            this.form.procedimentos = this.clone(data.form.procedimentos)
                            this.form.status = this.clone(data.form.status)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                }
            }
        },
        ocupacaoChange() {

            this.model.usuarioId = null
            this.model.procedimentoId = null
            this.model.status = null

            this.form.usuarios = []
            this.form.procedimentos = []
            this.form.status = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioQuantitativoProducao.list(filter)
                    .then(({ data }) => {

                        this.form.usuarios = this.clone(data.form.usuarios)
                        this.form.procedimentos = this.clone(data.form.procedimentos)
                        this.form.status = this.clone(data.form.status)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        usuarioChange() {

            this.model.procedimentoId = null
            this.model.status = null

            this.form.procedimentos = []
            this.form.status = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioQuantitativoProducao.list(filter)
                    .then(({ data }) => {

                        this.form.procedimentos = this.clone(data.form.procedimentos)
                        this.form.status = this.clone(data.form.status)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        procedimentoChange() {

            this.model.status = null

            this.form.status = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioQuantitativoProducao.list(filter)
                    .then(({ data }) => {

                        this.form.status = this.clone(data.form.status)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        imprimir() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const filter = this.getFilterExportPrint()

                    this.repositories.impressao.relatorioQuantitativoProducao(filter)
                        .then(response => {

                            this.download(response)
                        })
                        .finally(() => this.unsetLoading())
                })
        },
        exportar() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const filter = this.getFilterExportPrint()

                    this.repositories.export.exportQuantitativoProducao(filter)
                        .then(response => {

                            this.download(response)
                        })
                        .finally(() => this.unsetLoading())
                })
        },
        getFilterExportPrint() {

            const filter = this.getFilter()
            const $this = this

            const cols = this.fields.map(function (field) {

                field.key = $this.camelToSnake(field.key)

                return field
            })

            filter.columns = cols

            const unidade = this.form.unidades.find(u => u.id === this.model.unidadeId)
            filter.unidade = unidade ? unidade.nomeFantasia : 'Todas'

            const localAtendimento = this.form.locaisAtendimento.find(l => l.id === this.model.localAtendimentoId)
            filter.local_atendimento = localAtendimento ? localAtendimento.nome : 'Todos'

            const ocupacao = this.form.ocupacoes.find(o => o.id === this.model.ocupacaoId)
            filter.ocupacao = ocupacao ? ocupacao.nome : 'Todos'

            const procedimento = this.form.procedimentos.find(p => p.id === this.model.procedimentoId)
            filter.procedimento = procedimento ? procedimento.nome : 'Todos'

            const status = this.form.status.find(s => s.valor == this.model.status)
            filter.status_nome = status ? status.nome : 'Todos'

            return filter
        },
        getFilter() {

            if (this.isPeriodoFill) {

                const filter = this.clone(this.model)
                filter.periodo.date.start = this.getFormatedDate(filter.periodo.date.start, 'DD/MM/YYYY')
                filter.periodo.date.end = this.getFormatedDate(filter.periodo.date.end, 'DD/MM/YYYY')

                return this.camelObjectKeysToSnakeRecursive(filter)
            }

            return null
        },
        download(response) {

            const content = new Blob([response.data], {type: response.headers['content-type']})
            const url = URL.createObjectURL(content)
            const link = document.createElement('a')

            link.href = url
            link.target = '_blank'
            link.click()
            link.remove()
        },
        limpar() {

            this.form = this.clone(this.filterDefault.form)
            this.model = this.clone(this.filterDefault.model)
            this.$refs.RkmForm.resetValidator()
        }
    },
    mixins: [ repository, error, data, object, stringCase, formats ],
    watch: {
        'selectedCols': function (newValue) {

            this.indeterminate = false

            if (newValue.length > 0 && newValue.length != this.cols.length) {

                this.indeterminate = true
            }
        }
    }
}
</script>

<style scoped>
    .total {
        text-align: right;
        font-weight: bold;
    }

    .dropdown >>> .auto-scroll {
        max-height: 300px;
        overflow: auto;
    }
</style>